import { Http } from '@/lib/http';

export class ExternalParticipantsSettingsService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/external-participants';
  }

  /**
   * Retrieve all external participants settings.
   */
  getSettings(page, limit, type, name) {
    let query = [];
    if(page) {
      query.push(`page=${page}`)
    }
    if(limit) {
      query.push(`limit=${limit}`)
    }
    if(type) {
      query.push(`type=${type}`)
    }
    if(name) {
      query.push(`name=${name}`)
    }
    if(query.length > 0 ){
      query.unshift('?')
    }
    query = query.join('&');
    return this.httpClient().get(`${this.endpoint}${query}`);
  }

  /**
   * Create new external participants settings.
   */
  createSetting(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  /**
   * Update existing external participants settings.
   */
  updateSetting({ id, payload }) {
    return this.httpClient().put(`${this.endpoint}/${id}/`, payload);
  }

  /**
   * Remove external participants settings.
   *
   * @param {String} id - The ID of the external participants settings to remove.
   */
  removeSetting(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}/`);
  }

  /**
   * Updates the active status of all settings.
   */
  setAllActiveStatus({ isActive }) {
    return this.httpClient().patch(`${this.endpoint}/activate/${isActive}`);
  }
}
